export default "__VITE_ASSET__BDBiEua9__"